import { StateUpdaterMap } from "src/model/manager/state-manager";
import { AppState } from "..";
import { UserCookies, UserDataProfile } from "../partials/profile.model";

export interface ProfileActions {
    PRF_SET_LOADING: boolean;
    PRF_SET: UserDataProfile | null;
    PRF_NEEDS_LOGIN: undefined;
    PRF_SESSION_EXPIRED: undefined;
    PRF_SET_ERROR: string | null;
}

export const profileActions: StateUpdaterMap<AppState, ProfileActions> = {
    PRF_SET_LOADING: (loading, prevState) => ({
        profile: {
            ...prevState.profile,
            error: loading ? null : prevState.profile.error,
            loading
        }
    }),
    PRF_SET: (userDataProfile, _) => ({ 
        profile: { 
            loading: false,
            loaded: true, 
            user: userDataProfile?.user, 
            sessionExpired: false, 
            needsToLogin: false,
            lastLoad: Date.now(),
            error: null,
            userFromCookies: userDataProfile?.userFromCookies
        }
    }),
    PRF_NEEDS_LOGIN: (_, prevState) => ({
        profile: {
            ...prevState.profile,
            error: null,
            loading: false,
            user: null,
            needsToLogin: true,
            sessionExpired: false
        }
    }),
    // disable session expired for now
    PRF_SESSION_EXPIRED: (expired, prevState) => ({
        profile: {
            ...prevState.profile,
            error: null,
            loading: false,
            user: null,
            needsToLogin: true,
            sessionExpired: false
        }
    }),
    PRF_SET_ERROR: (messageKey, prevState) => ({
        profile: {
            ...prevState.profile,
            loading: false,
            error: messageKey ? {
                titleKey: null,
                messageKey
            } : null
        }
    }),
}